import React, {Component} from 'react';
import {Route, Switch} from 'react-router-dom';
import * as router from 'react-router-dom';
import {Container} from 'reactstrap';
import './Style.css'
import {
  AppFooter,
  AppHeader,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppBreadcrumb2 as AppBreadcrumb,
  AppSidebarNav2 as AppSidebarNav, AppSidebarMinimizer,
} from '@coreui/react';
// sidebar nav config
import navigation from '../../_notification_panel_nav';
// routes config
import routes from '../../routes';
import './Style.css'
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";
import Cookies from "js-cookie";

import DefaultHeader from "./NotificationHeader";
import DefaultFooter from "../DefaultLayout/DefaultFooter";



class NotificationLayout extends Component {
  state = {
    loader: true
  };

  loading = () => <span/>;
  manageIframe = () => {
    this.setState({
      loader: false
    })
  };

  signOut(e) {
    e.preventDefault();
    Cookies.remove("3c8bed3b2d6ba6d3076ee8d2f588a4dd");
    Cookies.remove("68a6102f6ed24899420170004a0273b8");
    this.props.history.push('/login')
  }


  render() {
    let type = this.props.system_changer;
    if (type === 5)
      document.title = "Miracle Dome";
    if (type === 3)
      document.title = "Miracle Dome";
    if (type === 2)
      document.title = "Miracle Dome";
    if (type === 1)
      document.title = "Miracle Dome";

    return (
      <div className="app">
        <AppHeader fixed>
          <DefaultHeader onLogout={e => this.signOut(e)}/>
        </AppHeader>

        {
          this.props.system_changer === 1 ?
            <div className="app-body">
              <AppSidebar className="navBarWidth" fixed display="lg">
                <AppSidebarHeader/>
                <AppSidebarForm/>

                <AppSidebarNav className="navBarWidth" navConfig={navigation} {...this.props} router={router}/>

                <AppSidebarFooter/>
                <AppSidebarMinimizer/>
              </AppSidebar>
              <main className="main margin-left239">
                <AppBreadcrumb appRoutes={routes} router={router}/>
                <Container fluid>

                  <Switch>
                    {routes.map((route, idx) => {
                      return route.component ? (
                        <Route
                          key={idx}
                          path={route.path}
                          exact={route.exact}
                          name={route.name}
                          render={props => (
                            <route.component {...props} />
                          )}/>
                      ) : (null);
                    })}
                  </Switch>

                </Container>
              </main>

            </div>
            : null
            // this.props.system_changer === 2 ?
            //   <div className="app-body">
            //     <AppSidebar className="navBarWidth" fixed display="lg">
            //       <AppSidebarHeader/>
            //       <AppSidebarForm/>
            //
            //       <AppSidebarNav className="navBarWidth" navConfig={visitorTagNavigation} {...this.props}
            //                      router={router}/>
            //
            //       <AppSidebarFooter/>
            //       <AppSidebarMinimizer/>
            //     </AppSidebar>
            //     <main className="main margin-left239">
            //       <AppBreadcrumb appRoutes={routes} router={router}/>
            //       <Container fluid>
            //
            //         <Switch>
            //           {routes.map((route, idx) => {
            //             return route.component ? (
            //               <Route
            //                 key={idx}
            //                 path={route.path}
            //                 exact={route.exact}
            //                 name={route.name}
            //                 render={props => (
            //                   <route.component {...props} />
            //                 )}/>
            //             ) : (null);
            //           })}
            //         </Switch>
            //
            //       </Container>
            //     </main>
            //
            //   </div>
            //   :
            //   this.props.system_changer === 3 ?
            //     <div className="app-body">
            //       {
            //         this.state.loader ?
            //           <div>
            //             <div className="ant-modal-mask" style={{background: 'rgba(239, 239, 239, 0.4)'}}>
            //             </div>
            //
            //             <div tabIndex="-1" style={{zIndex: '10000'}} className="ant-modal-wrap vertical-center-modal"
            //                  role="dialog">
            //               <div className={"wrap-sweet-loading"}>
            //                 <div className='sweet-loading'>
            //                   <PropagateLoader
            //                     sizeUnit={"px"}
            //                     size={this.props.size ? this.props.size : 15}
            //                     color={this.props.color ? this.props.color : '#0085ca'}
            //                     loading={this.state.loading}
            //                   />
            //                 </div>
            //
            //               </div>
            //             </div>
            //           </div>
            //           : null
            //       }
            //       <iframe src="/parktags/index.html" className={"iframe-tags parktags-iframe"} id={"iframe"}
            //               onLoad={this.manageIframe}/>
            //     </div>
            //     :
            //     this.props.system_changer === 4 ?
            //       <div className="app-body">
            //         <AppSidebar className="navBarWidth" fixed display="lg">
            //           <AppSidebarHeader/>
            //           <AppSidebarForm/>
            //
            //           <AppSidebarNav className="navBarWidth" navConfig={navigationEvent} {...this.props}
            //                          router={router}/>
            //
            //           <AppSidebarFooter/>
            //           <AppSidebarMinimizer/>
            //         </AppSidebar>
            //         <main className="main margin-left239">
            //           <AppBreadcrumb appRoutes={routes} router={router}/>
            //           <Container fluid>
            //
            //             <Switch>
            //               {routes.map((route, idx) => {
            //                 return route.component ? (
            //                   <Route
            //                     key={idx}
            //                     path={route.path}
            //                     exact={route.exact}
            //                     name={route.name}
            //                     render={props => (
            //                       <route.component {...props} />
            //                     )}/>
            //                 ) : (null);
            //               })}
            //             </Switch>
            //
            //           </Container>
            //         </main>
            //
            //       </div>
            //     :
            //     this.props.system_changer === 5 ?
            //       <div className="app-body">
            //         <AppSidebar className="navBarWidth" fixed display="lg">
            //           <AppSidebarHeader/>
            //           <AppSidebarForm/>
            //
            //           <AppSidebarNav className="navBarWidth" navConfig={navigationSpace} {...this.props}
            //                          router={router}/>
            //
            //           <AppSidebarFooter/>
            //           <AppSidebarMinimizer/>
            //         </AppSidebar>
            //         <main className="main margin-left239">
            //           <AppBreadcrumb appRoutes={routes} router={router}/>
            //           <Container fluid>
            //
            //             <Switch>
            //               {routes.map((route, idx) => {
            //                 return route.component ? (
            //                   <Route
            //                     key={idx}
            //                     path={route.path}
            //                     exact={route.exact}
            //                     name={route.name}
            //                     render={props => (
            //                       <route.component {...props} />
            //                     )}/>
            //                 ) : (null);
            //               })}
            //             </Switch>
            //
            //           </Container>
            //         </main>
            //
            //       </div>
            //     :null
        }

        {
          this.props.system_changer !== 3 ?
            <AppFooter>
              <DefaultFooter/>
            </AppFooter>
            : null
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  system_changer: state.systemChangeReducer.system_changer
});

const mapDispatchToProps = (dispatch) => {
  return {
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data)),
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    // dashboard details handler
    addTagsDashboard: (data) => dispatch(actionCreator.addTagsDashboard(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationLayout);
